import { render, staticRenderFns } from "./SliderTextFixed.vue?vue&type=template&id=658b34c2&"
import script from "./SliderTextFixed.vue?vue&type=script&lang=js&"
export * from "./SliderTextFixed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports